'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _i18next = require('i18next');

var _i18next2 = _interopRequireDefault(_i18next);

var _i18nextXhrBackend = require('i18next-xhr-backend');

var _i18nextXhrBackend2 = _interopRequireDefault(_i18nextXhrBackend);

var _Viewer = require('../components/Viewer');

var _Viewer2 = _interopRequireDefault(_Viewer);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.fs_hidden_fields = [];

var Viewer = function (_React$Component) {
  (0, _inherits3.default)(Viewer, _React$Component);

  function Viewer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Viewer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Viewer.__proto__ || (0, _getPrototypeOf2.default)(Viewer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      schema: undefined,
      formName: undefined,
      cssPrefix: undefined,
      translationLoaded: false
    }, _this.setTranslationLoaded = function () {
      return _this.setState({ translationLoaded: true });
    }, _this.changeSchema = function (schema, uischema, formData) {
      var promise = new _promise2.default(function (resolve, reject) {
        var clonedSchema = _ramda2.default.clone(_this.state.schema);
        clonedSchema.schema.schema = schema;
        clonedSchema.schema.uiSchema = uischema;

        _this.setState({ schema: clonedSchema }, resolve);
      });

      return promise;
    }, _this.saveSchema = function (data) {
      if ((typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) === 'object') {
        var _this$props = _this.props,
            formId = _this$props.formId,
            onSubmit = _this$props.onSubmit,
            onError = _this$props.onError,
            onInit = _this$props.onInit,
            apiRoot = _this$props.apiRoot,
            dataProcessor = _this$props.dataProcessor;

        _this.setState({ formName: data.formName, cssPrefix: data.cssPrefix });
        var newData = (0, _extends3.default)({}, data);

        if ('schema' in data) {
          if (typeof newData.schema.uiSchema.formMetaData === 'string') {
            newData.schema.uiSchema.formMetaData = {
              submitUrl: apiRoot + '/forms/api/v1/data/' + formId
            };
          } else {
            newData.schema.uiSchema.formMetaData.submitUrl = apiRoot + '/forms/api/v1/data/' + formId;
          }
          _this.setState({ schema: (0, _extends3.default)({}, newData, {
              onSubmit: onSubmit,
              onError: onError,
              onInit: onInit,
              dataProcessor: dataProcessor
            }) });

          return _promise2.default.resolve(data);
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Viewer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var _props = this.props,
          apiRoot = _props.apiRoot,
          formId = _props.formId,
          hidden = _props.hidden,
          readonly = _props.readonly,
          preset = _props.preset,
          debug = _props.debug;


      window.fs_hidden_fields = this.props.hidden;

      (0, _utils.getSchema)({ formId: formId, apiRoot: apiRoot, readonly: readonly, preset: preset }).then(this.saveSchema).then(function (_ref2) {
        var lng = _ref2.lang;
        return _i18next2.default.use(_i18nextXhrBackend2.default).init({
          lng: lng,
          debug: false,
          fallbackLng: lng || 'ru',
          ns: ['validation', 'placeholders'],
          defaultNS: 'validation',
          backend: {
            loadPath: (!debug && apiRoot || '') + '/assets/i18n/{{lng}}/{{ns}}.json',
            crossDomain: true
          }
        }, _this2.setTranslationLoaded);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          schema = _state.schema,
          formName = _state.formName,
          cssPrefix = _state.cssPrefix,
          translationLoaded = _state.translationLoaded;

      if (!schema || !translationLoaded) return null;

      var _props2 = this.props,
          formId = _props2.formId,
          preset = _props2.preset,
          hidden = _props2.hidden,
          readonly = _props2.readonly,
          onChange = _props2.onChange;


      if (schema && (typeof schema === 'undefined' ? 'undefined' : (0, _typeof3.default)(schema)) === 'object' && 'schema' in schema) {
        return _react2.default.createElement(
          'div',
          { className: 'row', 'data-form-name': formName },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12' },
            _react2.default.createElement(_Viewer2.default, {
              changeSchema: this.changeSchema,
              schemaData: schema,
              cssPrefix: cssPrefix,
              onChange: onChange,
              formId: formId,
              i18nInstance: _i18next2.default.cloneInstance(),
              i18nPath: 'validation:widget.',
              preset: preset,
              hidden: hidden || [],
              readonly: readonly || []
            })
          )
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'form-service-error' },
        schema
      );
    }
  }]);
  return Viewer;
}(_react2.default.Component);

Viewer.propTypes = {
  formId: _react.PropTypes.string.isRequired,
  apiRoot: _react.PropTypes.string.isRequired,
  onSubmit: _react.PropTypes.func,
  onChange: _react.PropTypes.func,
  onError: _react.PropTypes.func,
  onInit: _react.PropTypes.func,
  dataProcessor: _react.PropTypes.func,
  preset: _react.PropTypes.object,
  hidden: _react.PropTypes.array,
  readonly: _react.PropTypes.array
};

Viewer.defaultProps = {
  onSubmit: _utils.noop,
  onChange: _utils.noop,
  onError: _utils.noop,
  onInit: _utils.noop,
  dataProcessor: _utils.noop,
  preset: {},
  hidden: [],
  readonly: []
};

exports.default = Viewer;


//////////////////
// WEBPACK FOOTER
// ./~/form-service/frontend/lib/scenes/ViewerApp.js
// module id = 1126
// module chunks = 5